var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefundMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.2 21.2",
    style: {
      enableBackground: "new 0 0 21.2 21.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E81C8C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,2.8c3.9-3.2,9.7-3,13.4,0.7c3.9,3.9,3.9,10.2,0,14.1s-10.2,3.9-14.1,0c-2.4-2.4-3.4-5.9-2.7-9.3L0.9,8 l1.9,0.5c-1.1,4.3,1.4,8.6,5.7,9.8c4.3,1.1,8.6-1.4,9.8-5.7S16.9,4,12.6,2.8c-2.3-0.6-4.8-0.1-6.7,1.3L5.7,4.3l1,1L2.1,6.3l1.1-4.6 L4.3,2.8L4.3,2.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,9.8H4V8.5h1.5c0.8-2.2,2.8-3.7,5.3-3.7c2.3,0,4.3,1.2,5.1,3.3h-2.2c-0.6-1.1-1.6-1.7-2.9-1.7C9.2,6.5,8,7.3,7.4,8.5 h3.4v1.2H7c0,0.2,0,0.5,0,0.7s0,0.5,0,0.7h3.7v1.2H7.4c0.6,1.3,1.8,2.1,3.4,2.1c1.3,0,2.4-0.6,2.9-1.7h2.2 c-0.8,2.2-2.8,3.3-5.1,3.3c-2.5,0-4.6-1.4-5.3-3.7H4v-1.2h1.2c0-0.2,0-0.5,0-0.7S5.1,10,5.2,9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundMoney);
export default __webpack_public_path__ + "static/media/icon-refund-money.2c2182df8a7eeb2ac25fdeb094f3ea23.svg";
export { ForwardRef as ReactComponent };